"use client";

import React, { FC } from "react";
import { useRouter } from "next/navigation";
import { useStyles } from "./styles";
import { applyFirstEditionDefaults } from "utils/cta";
import { FaCheck } from "react-icons/fa";
import { MdClose } from "react-icons/md";

interface ChatBubbleContent {
  modalTitle?: string;
  feature1?: string;
  feature2?: string;
  feature3?: string;
}

interface ChatBubbleProps {
  onClose: () => void;
  onUpgrade: () => void;
  ctaContent?: ChatBubbleContent;
  versionIdentifier?: string;
  renderAbove?: boolean;
}

const ChatBubble: FC<ChatBubbleProps> = ({
  onClose,
  onUpgrade,
  ctaContent,
  versionIdentifier,
  renderAbove = false,
}) => {
  const router = useRouter();
  const { classes, cx } = useStyles();

  const defaults: ChatBubbleContent = {
    modalTitle: "Unlock HD Generation",
    feature1: "Crisp, high-resolution images",
    feature2: "Priority generation queue",
    feature3: "Unlimited daily generations",
  };

  const content = applyFirstEditionDefaults(
    versionIdentifier,
    "A",
    defaults,
    ctaContent
  );

  const features = [content.feature1, content.feature2, content.feature3];

  return (
    <div
      className={cx(
        classes.tooltip,
        renderAbove ? classes.tooltipAbove : classes.tooltipBelow
      )}
    >
      <div
        className={cx(
          classes.tooltipContent,
          renderAbove
            ? classes.tooltipContentAbove
            : classes.tooltipContentBelow
        )}
      >
        <button className={classes.dismiss} onClick={onClose}>
          <MdClose />
        </button>

        <h3 className={classes.tooltipTitle}>
          <FaCheck style={{ marginRight: 10 }} />
          {content.modalTitle}
        </h3>

        <ul className={classes.featureList}>
          {features.map((feature, idx) => (
            <li key={idx} className={classes.featureItem}>
              <FaCheck />
              {feature}
            </li>
          ))}
        </ul>

        <button
          className={classes.ctaButton}
          onClick={() => {
            onUpgrade();
            router.push("/subscribe");
          }}
        >
          UPGRADE NOW
        </button>
      </div>
    </div>
  );
};

export default ChatBubble;
